module.exports = __webpack_public_path__ + "img/b2.3ec3c2d.png";